import React, { Component } from 'react';

import logError from '../../common/helpers/rollbarHelper';
import Error from '../../error/Error';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error, info) {
    this.setState((state) => ({ ...state, hasError: true }));
    logError(error, info);
    console.log(error); // eslint-disable-line
    console.log(info); // eslint-disable-line
  }

  render() {
    const { state, props } = this;
    const { children } = props;
    const { hasError } = state;

    if (!hasError) {
      return children;
    }

    return <Error />;
  }
}

export default ErrorBoundary;
